/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Ref_TitleInputs */

const en_to_yaml_ref_title = /** @type {(inputs: To_Yaml_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How values are written in the output`)
};

const ko_to_yaml_ref_title = /** @type {(inputs: To_Yaml_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출력에서 값이 작성되는 방식`)
};

const ja_to_yaml_ref_title = /** @type {(inputs: To_Yaml_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力で値が書かれる形`)
};

/**
* | output |
* | --- |
* | "How values are written in the output" |
*
* @param {To_Yaml_Ref_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_ref_title = /** @type {((inputs?: To_Yaml_Ref_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Ref_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_ref_title(inputs)
	if (locale === "ko") return ko_to_yaml_ref_title(inputs)
	return ja_to_yaml_ref_title(inputs)
});